<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader> Editer l'utilisateur </CCardHeader>
					<CCardBody class="tab-body">
						<CRow v-if="loading" alignHorizontal="center">
							<CSpinner color="info" />
						</CRow>
						<CTabs v-else :active-tab="tab" v-on:update:activeTab="updateTab">
							<CTab title="Général" active>
								<CRow>
									<CCol sm="12">
										<ClientGeneralForm v-if="user.id" :user="user" />
									</CCol>
								</CRow>
							</CTab>
							<CTab title="Adresses">
								<CRow>
									<CCol sm="12">
										<ClientAddressesForm
											v-if="user.id"
											v-on:update:addresses="updateAddresses"
											v-on:refresh:user="retrieveUser"
											:user="user" />
									</CCol>
								</CRow>
							</CTab>
							<CTab title="Commandes">
								<CRow>
									<CCol sm="12">
										<ClientOrders v-if="user.id" :user="user" />
									</CCol>
								</CRow>
							</CTab>
						</CTabs>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
	</div>
</template>

<script>
	import ClientGeneralForm from './_components/ClientGeneralForm';
	import ClientAddressesForm from './_components/ClientAddressesForm';
	import ClientOrders from './_components/ClientOrders';

	export default {
		components: { ClientOrders, ClientAddressesForm, ClientGeneralForm },
		data() {
			return {
				user: {},
				password: null,
				loading: false,
				tab: 0,
			};
		},
		methods: {
			retrieveUser() {
				this.loading = true;
				this.$axios
					.get(`/api/users/${this.$route.params.id}`)
					.then(res => {
						this.user = res.data;
						this.loading = false;
					})
					.catch(err => {
						this.$toast.error(
							"Une erreur s'est produite lors de la récupération de l'utilisateur, contactez un administrateur"
						);
						this.loading = false;
					});
			},
			updateAddresses(updatedAddress) {
				const index = this.user.addresses.findIndex(
					address => address['@id'] === updatedAddress['@id']
				);
				this.$set(this.user.addresses, index, updatedAddress);
			},
			updateTab(tab) {
				if (this.tab === tab) {
					return;
				}

				const query = Object.assign({}, this.$route.query);
				query.tab = tab;
				this.tab = tab;
				this.$router.push({ query });
			},
			setTab() {
				this.tab = Number(this.$route.query.tab);
			},
		},
		mounted() {
			this.retrieveUser();
			this.setTab();
		},
	};
</script>
